import React from "react"
import { Box, Typography, useTheme } from "@carrotfertility/carotene-core"

interface ReimbursementDescriptionGroupProps {
  title: React.ReactNode
  value: React.ReactNode
}

export function ReimbursementDescriptionList({ children }: React.PropsWithChildren) {
  return (
    <Box
      component="dl"
      sx={(theme) => ({
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: theme.tokens.spacing.md,
        margin: 0
      })}
    >
      {children}
    </Box>
  )
}

export function ReimbursementDescriptionGroup({ title, value }: ReimbursementDescriptionGroupProps) {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minInlineSize: { xs: "64px", md: "120px" }
      }}
    >
      <Typography
        component="dt"
        variant="body1"
        fontWeight="normal"
        fontStyle="normal"
        color={(theme) => theme.palette.text.secondary}
        sx={{ ...theme.typography.label }}
      >
        {title}
      </Typography>
      <Typography
        component="dd"
        variant="body1"
        color={(theme) => theme.palette.text.secondary}
        sx={{ marginInlineStart: 0 }}
      >
        {value}
      </Typography>
    </Box>
  )
}
